export default __webpack_public_path__ + "static/media/dark_reader_icon.2041d40e.svg";